import type { TypePolicies } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

export const cardShopCachePolicies: TypePolicies = {
  StationeryTemplateContainer: {
    fields: {
      pagedResults: relayStylePagination(),
    },
  },

  // StationeryTag doesn't have an `id` field, so we'll
  // use the unique `name` field as the key.
  StationeryTag: {
    keyFields: ['name'],
  },
  StationeryAttributeOption: {
    keyFields: ['id', 'attributeId'],
  },
  StationeryProductShippingOptionV1: {
    keyFields: ['id', 'constraints', 'pricing'],
  },
  // `stationeryPrintOrdersByEvent` returns this view, which has no `id`, so it is stored inline and each write
  // replaced the last. The Cards nav count selects only `count` and wiped the `orders` that the order
  // history and Your Cards had written, and those queries refetched (MSG-477). Merge the fields instead;
  // `orders` is still replaced as a whole.
  StationeryPrintOrdersView: {
    merge: true,
  },
};
